<template>
  <div class="assign-task flex flex-col">
    <!-- <div>
      <el-button @click="back">返回</el-button>
    </div> -->
    <!-- 提示信息 提示已选中那些人 -->
    <div class="content flex flex-col items-center justify-center">
      <div class="top-tips">
        <i class="el-icon-warning mx-2"></i>
        <span>已选中 {{ peopleName.slice(0, 3).join('、') }} 等共{{ peopleName.length }}人</span>
      </div>

      <!-- 任务信息 -->
      <div class="w-1/2 my-3 text-sm">任务信息：</div>

      <div class="form-content">
        <el-form ref="taskRuleForm" :label-position="labelPosition" label-width="140px" :model="formLabelAlign" :rules="rules">
          <el-form-item :style="{ marginBottom: '0' }" label="结算类型：" prop="settleMethod">
            <div class="flex">
              <div class="inline-block">
                <div
                  class="btn-box btn1 box-border"
                  :class="{ 'btn-checked': btnChecked == 'online' }"
                  @click="changeSettleMethod('online')"
                >
                  <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'online')" :value="true"></el-checkbox>
                  <div>
                    <div class="text-theme-black-650 text-medium mb-2 font-semibold">
                      线上结算
                      <div class="tujian bg-yellow-theme text-white inline-block text-center font-semibold text-small">推荐</div>
                    </div>
                    <div class="text-theme-black-450 text-small">
                      线上支付调查员费用，调研工厂代调查员纳税，并为您的总花费开具发票
                    </div>
                    <div class="flex justify-between mt-1" v-if="!isOpen">
                      <span class="text-yellow-theme text-small">
                        <i class="iconfont icon-jingshishuoming text-small font-semibold"></i>
                        尚未开通，无法使用
                      </span>
                      <span class="cursor-pointer text-theme text-small" @click="toOpen">去开通></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="inline-block">
                <div
                  class="btn-box btn2 box-border"
                  :class="{ 'btn-checked': btnChecked == 'offline' }"
                  @click="changeSettleMethod('offline')"
                >
                  <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'offline')" :value="true"></el-checkbox>
                  <div>
                    <div class="text-theme-black-650 text-medium mb-2 font-semibold">线下结算</div>
                    <div class="text-theme-black-450 text-small">
                      常用场景：线下与调查员签署劳务协议、协商支付方式、纳税事宜等
                    </div>
                  </div>
                </div>
              </div>
              <div class="inline-block">
                <div
                  class="btn-box btn2 box-border"
                  :class="{ 'btn-checked': btnChecked == 'neednot' }"
                  @click="changeSettleMethod('neednot')"
                >
                  <el-checkbox class="position-checkbox" :disabled="!(btnChecked == 'neednot')" :value="true"></el-checkbox>
                  <div>
                    <div class="text-theme-black-650 text-medium mb-2 font-semibold">无需结算</div>
                    <div class="text-theme-black-450 text-small">常用场景：已同调查员签署劳动合同或调查员愿提供无偿服务等</div>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            :style="{ marginBottom: formLabelAlign.settleMode ? '0' : '18px' }"
            label="结算方式："
            prop="settleMode"
            :rules="[{ required: !(!isOpen && formLabelAlign.settleMethod == 0), message: ' ', trigger: 'change' }]"
          >
            <el-radio-group
              v-model="formLabelAlign.settleMode"
              @change="changeSettlementType"
              :disabled="!isOpen && formLabelAlign.settleMethod == 0"
            >
              <el-radio :label="1">按答卷数量</el-radio>
              <el-radio :label="2">按天</el-radio>
              <el-radio v-if="!(btnChecked == 'neednot')" :label="3">按阶梯计价</el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 1">
            <div class="flex-box" v-if="formLabelAlign.settleMethod != 2">
              <el-form-item
                label="单价（元）:"
                prop="settleRule.unitPriceYuan"
                :rules="[
                  {
                    required: !((!isOpen && formLabelAlign.settleMethod == 0) || formLabelAlign.settleMethod == 2),
                    message: ' ',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input-number
                  placeholder=""
                  v-model="formLabelAlign.settleRule.unitPriceYuan"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="2"
                  :disabled="(!isOpen && formLabelAlign.settleMethod == 0) || formLabelAlign.settleMethod == 2"
                >
                </el-input-number>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="settlement-tips" v-if="formLabelAlign.settleMethod != 2">
              若用线上结算，请填写调查员到手金额，到手金额
              <el-button type="text" @click="dialVisible = true">计算器</el-button>
            </div>
            <div class="flex-box">
              <span class="pos-abs-box">
                <i>*</i>
                答卷数量:
                <el-tooltip
                  effect="dark"
                  content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                  placement="top"
                >
                  <div class="icon-wrap" style="margin-left: 4px">
                    <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </span>
              <el-form-item
                label=""
                prop="settleRule.expectedQuantity"
                :rules="[{ required: !(!isOpen && formLabelAlign.settleMethod == 0), message: ' ', trigger: 'blur' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                  :disabled="!isOpen && formLabelAlign.settleMethod == 0"
                >
                </el-input-number>
              </el-form-item>
              <span>份</span>
            </div>
            <div class="settlement-tips" style="margin-bottom: 0" v-if="formLabelAlign.settleMethod != 2">
              预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元
            </div>
          </div>
          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 2">
            <div class="flex-box" v-if="formLabelAlign.settleMethod != 2">
              <el-form-item
                label="单价（元）:"
                prop="settleRule.unitPriceYuan"
                :rules="[
                  {
                    required: !((!isOpen && formLabelAlign.settleMethod == 0) || formLabelAlign.settleMethod == 2),
                    message: ' ',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.unitPriceYuan"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="2"
                  :disabled="(!isOpen && formLabelAlign.settleMethod == 0) || formLabelAlign.settleMethod == 2"
                >
                </el-input-number>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="settlement-tips" v-if="formLabelAlign.settleMethod != 2">
              若用线上结算，请填写调查员到手金额，到手金额
              <el-button type="text" @click="dialVisible = true">计算器</el-button>
            </div>
            <div class="flex-box">
              <span class="pos-abs-box">
                <i>*</i>
                天数:
                <el-tooltip
                  effect="dark"
                  content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                  placement="top"
                >
                  <div class="icon-wrap" style="margin-left: 4px">
                    <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </span>
              <el-form-item
                label=""
                prop="settleRule.expectedQuantity"
                :rules="[{ required: !(!isOpen && formLabelAlign.settleMethod == 0), message: ' ', trigger: 'blur' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                  :disabled="!isOpen && formLabelAlign.settleMethod == 0"
                >
                </el-input-number>
              </el-form-item>
              <span>天</span>
            </div>
            <div class="settlement-tips" style="margin-bottom: 0" v-if="formLabelAlign.settleMethod != 2">
              <div style="display: flex">
                <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                <el-tooltip
                  effect="dark"
                  :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                  placement="top"
                >
                  <div class="icon-wrap">
                    <span class="icon-font ico-tips">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 3">
            <el-form-item
              class="is-require-task"
              style="margin-bottom: 0"
              label="单价（元）:"
              v-if="formLabelAlign.settleMethod != 2"
            >
              <div
                class="flex-settlement"
                v-for="(item, index) in formLabelAlign.settleRule.tiers"
                :key="index"
                :style="{ marginBottom: index === formLabelAlign.settleRule.tiers.length - 1 ? '0px' : '5px' }"
              >
                <span style="margin-right: 8px" v-show="index === 0">每天</span>
                <el-form-item label>
                  <el-input-number
                    v-if="index === 0"
                    :disabled="true"
                    placeholder=""
                    v-model="item.quantityLowerBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="0"
                    :max="Infinity"
                    :precision="0"
                  >
                  </el-input-number>
                  <el-input-number
                    v-if="index > 0"
                    :disabled="true"
                    placeholder=""
                    :value="formLabelAlign.settleRule.tiers[index - 1].quantityUpperBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="0"
                    :max="Infinity"
                    :precision="0"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                <el-form-item
                  label
                  :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                  :rules="[
                    {
                      required: !((!isOpen && formLabelAlign.settleMethod == 0) || formLabelAlign.settleMethod == 2),
                      message: ' ',
                      trigger: 'blur'
                    }
                  ]"
                >
                  <el-input-number
                    placeholder=""
                    v-model="item.quantityUpperBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="index > 0 ? formLabelAlign.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                    :max="Infinity"
                    @change="val => currentInputNumber(val, item, index)"
                    :precision="0"
                    :disabled="(!isOpen && formLabelAlign.settleMethod == 0) || formLabelAlign.settleMethod == 2"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin: 0 8px">份，按完成量</span>
                <el-form-item
                  label
                  :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                  :rules="[
                    {
                      required: !((!isOpen && formLabelAlign.settleMethod == 0) || formLabelAlign.settleMethod == 2),
                      message: ' ',
                      trigger: 'blur'
                    }
                  ]"
                  style="margin-left: 10px"
                >
                  <el-input-number
                    placeholder=""
                    v-model.number="item.unitPriceYuan"
                    autocomplete="off"
                    controls-position="right"
                    :min="1"
                    :max="Infinity"
                    :precision="2"
                    :disabled="(!isOpen && formLabelAlign.settleMethod == 0) || formLabelAlign.settleMethod == 2"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin-left: 8px">元/份</span>
                <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                  ><i class="icon-font">&#xe68c;</i></el-button
                >
                <el-button
                  v-else-if="index === formLabelAlign.settleRule.tiers.length - 1"
                  @click="handleSettlement('remove', index)"
                  class="btn-style"
                  type="text"
                  ><i class="icon-font">&#xe68a;</i></el-button
                >
                <!-- <el-button @click="handleSettlement(index=== formLabelAlign.ladderSettlement.length-1 ? 'add' : 'remove')" class="btn-style" type="text"> {{index=== 0? '+':'-'}}</el-button> -->
              </div>
              <div class="settlement-tips left-0">
                若用线上结算，请填写调查员到手金额，到手金额
                <el-button type="text" @click="dialVisible = true">计算器</el-button>
              </div>
            </el-form-item>
            <div class="flex-box">
              <el-form-item
                style="margin-bottom: 0"
                label="天数:"
                prop="settleRule.expectedQuantity"
                :rules="[{ required: !(!isOpen && formLabelAlign.settleMethod == 0), message: ' ', trigger: 'blur' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                  :disabled="!isOpen && formLabelAlign.settleMethod == 0"
                >
                </el-input-number>
              </el-form-item>
              <span>天</span>
            </div>
          </div>

          <el-form-item label="任务名称：" prop="taskName">
            <el-input
              v-model="formLabelAlign.taskName"
              style="width: 50%"
              placeholder="请输入任务名称"
              :disabled="hasTitle"
            ></el-input>
          </el-form-item>
          <el-form-item label="截止时间：" prop="endTime">
            <el-date-picker
              type="datetime"
              placeholder="选择时间"
              v-model="formLabelAlign.endTime"
              style="width: 50%"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <!-- <el-form-item prop="count">
            <label slot="label"
              >答卷数量(个)
              <el-tooltip class="item" content="每名调查员需要完成的答卷数量" placement="top">
                <span class="el-icon-warning-outline"></span>
              </el-tooltip>
              ：</label
            >
            <el-input-number
              size="small"
              placeholder="请输入数量"
              v-model="formLabelAlign.count"
              :controls="true"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="答卷单价(元)：" prop="price">
            <el-input-number
              size="small"
              placeholder="支持两位小数、支持0和正数"
              v-model="formLabelAlign.price"
              :min="1"
              :precision="2"
              :controls="true"
              :step="0.01"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="预估费用：">
            <span>{{ aboutPrice }}元</span>
          </el-form-item> -->
          <el-form-item label="描述：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.detail" style="width: 50%"></el-input>
          </el-form-item>
          <el-form-item label="执行要求：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.requirement"></el-input>
          </el-form-item>
          <el-form-item label="质控标准：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.qulityStandard"></el-input>
          </el-form-item>
          <el-form-item label="结算标准：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.checkoutStandard"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="self-end">
      <el-button @click="back">取消</el-button>
      <el-button type="primary" @click="distributeTask">确认</el-button>
    </div>
    <over-mask
      :dialogVisible="dialVisible"
      @handleClose="
        () => {
          dialVisible = false
        }
      "
    ></over-mask>
  </div>
</template>

<script>
import { plCreat } from '@/api/wenjuan/addList.js'
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import { createFaceToFaceWorkNew } from '@/api/wenjuan/offline.js'
import GlobalConfig from '@/global/config'

export default {
  name: 'assignTask',
  components: { OverMask },
  props: {
    data: {
      type: Map
    },
    title: {
      type: String,
      default: ''
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      settleMethodMap: {
        online: 0,
        offline: 1,
        neednot: 2
      },
      btnCheckedMap: {
        0: 'online',
        1: 'offline',
        2: 'neednot'
      },
      btnChecked: 'online',
      isOpen: false,
      hasTitle: false, // 根据是否传入招募任务的标题来判断input输入框的状态
      peopleName: [],
      labelPosition: 'right',
      dialVisible: false,
      formLabelAlign: {
        taskName: '',
        endTime: '',
        count: '',
        price: '',
        detail: '',
        requirement: '',
        qulityStandard: '',
        checkoutStandard: '',
        settleMethod: 0,
        settleMode: '',
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      },
      rules: {
        taskName: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        endTime: [
          {
            type: 'string',
            required: true,
            message: '请选择截止时间',
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    toOpen() {
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    changeSettleMethod(btnType) {
      this.btnChecked = btnType
      this.formLabelAlign.settleMethod = this.settleMethodMap[btnType]
      this.changeSettlementType(1)
    },
    back() {
      this.$emit('comeback')
    },
    // 分配任务
    distributeTask() {
      if (!this.isOpen && this.formLabelAlign.settleMethod == 0) {
        this.$message({
          message: '尚未开通费用结算，无法设定线上结算',
          type: 'warning'
        })
        return
      }
      if (!this.formLabelAlign.taskName || !this.formLabelAlign.settleMode || !this.formLabelAlign.endTime) {
        this.$message.error('请将必填项填写完整！')
        return
      }
      // if(this.formLabelAlign.price < 0) {
      //   this.$message.error('请正确填写单价！');
      //   return;
      // }
      this.$refs['taskRuleForm'].validate(valid => {
        if (valid) {
          // 处理阶梯计价开始数量
          let postData = {}
          if (this.formLabelAlign.settleMode === 3) {
            const cloneLadderSettlement = [...this.formLabelAlign.settleRule.tiers]
            cloneLadderSettlement.forEach((it, i, arr) => {
              if (i > 0) {
                it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
              }
            })
            postData = {
              ...this.formLabelAlign,
              settleRule: {
                ...this.formLabelAlign.settleRule,
                tiers: cloneLadderSettlement
              }
            }
            // postData.ladderSettlement =cloneLadderSettlement;
            this.formLabelAlign = { ...postData }
          }
          let params = []
          let commonParams = {
            surveyId: GlobalConfig.getSurveyId(),
            executionName: this.formLabelAlign.taskName,
            // executionQuantity: this.formLabelAlign.count,
            // executionSingleAmount: this.formLabelAlign.price,
            executionValidateTo: this.formLabelAlign.endTime,
            executionDescription: this.formLabelAlign.detail || '',
            executionRequirement: this.formLabelAlign.requirement || '',
            qualityControlStandard: this.formLabelAlign.qulityStandard || '',
            settleStandard: this.formLabelAlign.checkoutStandard || '',
            settleMethod: this.formLabelAlign.settleMethod || 0,
            settleMode: this.formLabelAlign.settleMode || '',
            settleRule: this.formLabelAlign.settleRule
          }
          let userList = []
          for (let val of this.data.values()) {
            let temParam = Object.assign({}, commonParams)
            temParam.executionBy = val.executionBy || ''
            ;(temParam.executorPhone = val.executorPhone || val.contact), (temParam.userName = val.executorName || val.name)
            params.push(temParam)

            userList.push({
              userId: val.userId,
              userName: val.interviewerName,
              phone: val.contact,
              justForCode: false
            })
          }

          let newParams = Object.assign({}, commonParams)
          newParams.userList = userList

          if (this.id) {
            newParams.proxyJobId = this.id
            // 传入了id 调用新的创建面访任务
            createFaceToFaceWorkNew(newParams)
              .then(res => {
                if (res.data.code != 0) {
                  this.$message.error(res.data.msg)
                  return
                }
                this.$message.success('添加调查员任务成功！')
                this.$emit('comeback')
              })
              .catch(e => {
                this.$message.error(e.message)
              })
          } else {
            // 没有传入id 调用旧的方法
            plCreat(params)
              .then(res => {
                if (res.data.code === 0) {
                  this.$message.success('添加调查员任务成功！')
                  this.$emit('comeback')
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch(e => {
                this.$message.error(e.message)
              })
          }
        }
      })
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.formLabelAlign.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.formLabelAlign.settleRule = {
        ...this.formLabelAlign.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      this.$refs['taskRuleForm'].clearValidate()
      this.formLabelAlign = {
        ...this.formLabelAlign,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.formLabelAlign.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskRuleForm'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        console.log('validateArr:', validateArr)
        if (validFlag) {
          if (this.formLabelAlign.settleRule.tiers.length < 5) {
            const lastTiers = this.formLabelAlign.settleRule.tiers[this.formLabelAlign.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }

            const cloneLadderSettlement = this.formLabelAlign.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: undefined,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.formLabelAlign.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.formLabelAlign.settleRule.tiers

        this.formLabelAlign.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    }
  },
  computed: {
    aboutPrice() {
      let result = ((this.formLabelAlign.count * 100 * this.formLabelAlign.price) / 100 || 0).toFixed(2)
      if (Number.isNaN(result)) return 0
      return result
    },
    totalPriceYuan () {
      if (this.formLabelAlign.settleRule.expectedQuantity && this.formLabelAlign.settleRule.unitPriceYuan) {
        return (this.formLabelAlign.settleRule.expectedQuantity * this.formLabelAlign.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan () {
      if (this.formLabelAlign.settleRule.expectedQuantity && this.formLabelAlign.settleRule.unitPriceYuan) {
        return (
          (1 + this.accRate) *
          (this.formLabelAlign.settleRule.expectedQuantity * this.formLabelAlign.settleRule.unitPriceYuan)
        ).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  created() {
    this.isOpen = this.$store.getters.settlementType !== 1
    // 如果传入了招募任务的标题
    if (this.title) {
      this.formLabelAlign.taskName = this.title
      this.hasTitle = true
    }

    for (let val of this.data.values()) {
      if (val.executorName !== null) {
        this.peopleName.push(val.executorName)
      } else if (val.interviewerName) {
        this.peopleName.push(val.interviewerName)
      } else if (val.agentName) {
        this.peopleName.push(val.agentName)
      }
    }
  },
  beforeDestroy() {
    this.formLabelAlign.taskName = ''
    this.hasTitle = false
  }
}
</script>

<style lang="scss">
.assign-task {
  .content {
    .top-tips {
      width: 65%;
      background-color: #e6f7ff;
      border: 1px solid #a6ddff;
      padding: 3px;
      .el-icon-warning {
        color: #1890ff;
      }
    }
  }
  .form-content {
    width: 65%;
    .settlementType-style {
      .is-require-task {
        .el-form-item__label {
          &::before {
            content: '*';
            color: #e34152;
            margin-right: 4px;
          }
        }
      }
      .flex-box {
        display: flex;
        position: relative;
        .pos-abs-box {
          position: absolute;
          display: flex;
          justify-content: flex-end;
          width: 128px;
          padding-right: 12px;
          i {
            content: '*';
            color: #e34152;
            margin-right: 4px;
          }
        }
        & > span {
          line-height: 32px;
          margin-left: 8px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          font-weight: 400;
          font-family: PingFangSC-Regular;
        }
      }
      margin-bottom: 16px;
      padding: 12px;
      background-color: rgba(242, 242, 242, 0.624);
      .el-form-item {
        margin-bottom: 8px;
        .el-input-number {
          width: 88px;
          background: #f2f5fa;
          .el-input__inner {
            padding-left: 5px !important;
            padding-right: 25px !important;
          }
        }
        .el-input-number.is-controls-right .el-input__inner {
          background: #f2f5fa;
        }
        .el-input.is-disabled .el-input__inner {
          border-color: rgba(221, 221, 221, 1);
        }
        .el-input-number__decrease,
        .el-input-number__increase {
          background: #f2f5fa;
          .el-icon-arrow-down,
          .el-icon-arrow-up {
            color: rgba(0, 0, 0, 0.65);
            border-color: rgba(221, 221, 221, var(--tw-border-opacity));
          }
        }
      }
      .btn-style {
        margin-left: 5px;
      }
      .settlement-tips {
        margin-left: 100px;
        font-size: 12px;
        margin-bottom: 8px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);
        .el-button {
          font-size: 12px;
        }
        &.left-0 {
          margin-left: 0;
          margin-bottom: 0;
        }
      }
      .flex-settlement {
        display: flex;
        margin-bottom: 5px;
        align-items: center;
        .settlement-tips {
          margin-bottom: 0;
        }
        .el-form-item {
          margin-bottom: 0;
        }
        .el-input-number {
          width: 88px;
          background: #f2f5fa;
        }
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.btn-box {
  @apply flex justify-center;
  padding: 10px;
  min-height: 118px;
  width: 196px;
  border-radius: 2px;
  cursor: pointer;
  line-height: 16px;
  position: relative;
  .position-checkbox {
    position: absolute;
    right: 0;
    top: -2px;
  }
  &.btn1 {
    border: 1px solid #cccccc;
  }
  &.btn2 {
    border: 1px solid #cccccc;
    margin-left: 26px;
  }
  &.btn1.btn-checked,
  &.btn2.btn-checked {
    background: rgba(39, 117, 232, 0.1);
    border: 1px solid var(--theme-color) !important;
  }
  .tujian {
    border: 1px solid #faad14;
    border-radius: 8px;
    width: 34px;
    height: 16px;
    font-weight: 500;
    font-size: 12px;
  }
}
// .btn-checked div {
//   div {
//     color: #2775e8 !important;
//   }
//   i {
//     color: #2775e8 !important;
//   }
// }
.btn-box:hover {
  &.btn1,
  &.btn2 {
    background: rgba(39, 117, 232, 0.1);
    border: 1px solid var(--theme-color) !important;
    // div {
    //   div {
    //     color: #2775e8 !important;
    //   }
    //   i {
    //     color: #2775e8 !important;
    //   }
    // }
  }
}
</style>
